import { TextPostion } from 'flux-diagram-composer';
import { IPosition2D, ITransform, TextAlignment, TEXT_PADDING_HORIZONTAL } from 'flux-definition';
import { Rectangle } from 'flux-core';
import { TiptapTextView } from '../../../../framework/easeljs/tiptap-text-view';
import { ShapeTextModel } from '../../model/text/shape-text.mdl';

// tslint:disable:member-ordering
/**
 * TiptapShapeTextView extends TiptapTextView and implements functions specific to
 * shape texts
 */
export class TiptapShapeTextView extends TiptapTextView {

    // public static state: StateService<any, any>;

    constructor(  protected model: ShapeTextModel, protected shapeId ) {
        super( model , shapeId );
    }

    public update( model: ShapeTextModel, _change?: any,  _bounds?: Rectangle, _transfrom?: ITransform ) {
        this.change = _change;
        this.bounds = _bounds;
        if ( !_bounds ) {
            return;
        }
        this.updateViewCache( model, this.change );
        this.model = model;
        this.transfrom = _transfrom;
        if ( model.html ) {
            this.html = model.html;
            this.lineWidth = model.width;
        } else {
            this.html = '';
            this.lineWidth = 0;
        }
        this.updatePos();
        const bounds = { x: 0, y: 0, width: model.width, height: model.height };
        this.updateHitArea( model, bounds );
    }

    protected updatePos() {
        if ( this.bounds ) {
            const scale = this.transfrom ? this.transfrom.scaleX : 1 ;
            this.lineWidth = Math.abs( this.model.hitArea ? this.model.hitArea.width :
                 this.bounds.width * scale ) - ( 2 * TEXT_PADDING_HORIZONTAL );
            if ( this.model.width > this.lineWidth ) {
                this.lineWidth = this.model.width;
            }
            if ( this.cachedBounds ) {
                this.position( this.model.position, this.model.alignX,
                    this.model.alignY, this.cachedBounds as any, this.bounds, this.transfrom );
            } else {
                this.getShapeTextBounds().subscribe( textBounds => {
                    this.position( this.model.position, this.model.alignX,
                        this.model.alignY, textBounds as any, this.bounds, this.transfrom );
                });
            }
        }
    }

    /**
     * This function updates the position of the text
     * considering the text model values, shape bounds and trnsformation
     *
     * @param xPos number      A ratio to define the x position on the shape
     * @param yPos number      A ratio to define the y position on the shape
     * @param alignX TextAlignment  The horizontal text alignment
     * @param alignX TextAlignment  The vertical text alignment
     * @param shapeBounds Rectangle  The default bounds of the shape
     * @param transform  ITransform  The transformation of the text
     */
     protected position (
        pos: IPosition2D,
        alignX: TextAlignment,
        alignY: TextAlignment,
        textBounds: Rectangle,
        shapeBounds: any,
        transfrom: ITransform ) {

            const pointOnShape = TextPostion.getPointOnShape( pos, shapeBounds, transfrom );
            const pointOnText = TextPostion.getPointOnText( textBounds as any, alignX, alignY, transfrom );
            this.regX = pointOnText.x;
            this.regY = pointOnText.y;
            this.x = pointOnShape.x;
            this.y = pointOnShape.y;
            this.applyTransform( transfrom );
    }


    /**
     * This funciton applies tranforms to the text
     * @param transform  ITransform  The transformation of the text
     */
     protected applyTransform( transfrom: ITransform ) {
        if ( transfrom ) {
            // FIXME Do Dev Testing!! CJ - 28/01/2021 - @thisun check
            this.rotation = TextPostion.getTextAngle( transfrom );
            this.rotation = this.rotation + this.model.angle;
        }
    }

}
